<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .salary-section {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: utils.in_rem(15px);
  }

  .section-title {
    @include mixins.body2-bold();
  }

  .section-inputs {
    display: flex;
    flex-direction: column;
    gap: utils.in_rem(10px);

    .row {
      display: flex;
      width: 100%;
      justify-content: space-between;

      .row-item {
        flex: 1 1 calc(50% - utils.in_rem(13px));
        max-width: calc(50% - utils.in_rem(13px));
      }
    }
  }
</style>

<script>
  import TextInput from "@sourcewhale/shared/svelte-design-system/components/molecules/InputFields/TextInput.svelte";
  import { editContactStore } from "../../../stores";
</script>

<div class="salary-section">
  <div class="section-title">Current Salary</div>
  <div class="section-inputs">
    <div class="row">
      <div class="row-item">
        <TextInput label="Salary" bind:value={$editContactStore["salary"]} />
      </div>
      <div class="row-item">
        <TextInput
          label="Bonus"
          bind:value={$editContactStore["currentBonus"]}
        />
      </div>
    </div>
  </div>
</div>
